export function activityDirective() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      activity: '=',
    },
    transclude: true,
    template:
      '<span id="{{activity.id}}" class="label activity-label"><span>{{activity.name}}</span><div ng-transclude></div></span>',
    link: function (scope, element) {
      switch (scope.activity.type) {
        case 'PERSONAL':
          element.addClass('label-personal');
          break;
        case 'INTERNAL':
          element.addClass('label-internal');
          break;
        case 'BILLABLE':
          element.addClass('label-billable');
          break;
        case 'FIXED_PRICE':
          element.addClass('label-fixed-price');
          break;
      }
    },
  };
}
